import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom'


const Footer = ({ currentUser }) => {
const [pendingCount, setPendingCount] = useState(0);

useEffect(() => {
    // Only fetch if the logged-in user is an admin
    if (currentUser?.role === 'admin') {
      const fetchCount = async () => {
        try {
          const response = await fetch('/api/admin/pending-count');
          const data = await response.json();
          setPendingCount(data.count);
        } catch (err) {
          console.error("Error fetching badge count:", err);
        }
      };

      fetchCount();
      // Optional: Check for new applications every 5 minutes
      const interval = setInterval(fetchCount, 300000); 
      return () => clearInterval(interval);
    }
  }, [currentUser]);
  return (
    <div className='absolute left-0 right-0 bottom-0'>
<section className='footer_top flex bg-cyan-100 gap-2 justify-evenly justify-items-stretch w-full content-center overflow-x-scroll whitespace-nowrap scroll-smooth scrollbar-hide items-center'>
<Link to="/company" className=' text-black text-sm flex'>Company </Link>
<Link to="/contact" className=' text-black text-sm flex'>Contact Us </Link>
<Link to="/join" className=' text-black text-sm flex'>Become a Member </Link>
{currentUser?.role === 'admin' && (
<Link to="/support" className='inline-flex items-center gap-2 bg-blue-600 text-white px-4 py-2 rounded font-bold hover:bg-blue-700 transition shrink-0'><span>Tutor Approvals</span>
{pendingCount > 0 && (
              <span className="flex h-5 w-5 items-center justify-center rounded-full bg-red-600 text-[10px] text-white animate-pulse">
                {pendingCount}
              </span>
            )}
</Link> 
  )}
<Link to="/advice" className=' text-black text-sm flex'>Advise Us </Link>
<Link to="/admin" className=' text-black text-sm flex'>System Settings </Link>
<Link to="/interpret" className=' text-black text-sm flex'>How it Works </Link>
<Link to="/terms" className=' text-black  text-sm flex '>Terms of Services </Link>
<Link to="/privacy" className=' text-black text-sm flex'>Privacy Policy </Link>
<Link to="/testimony" className=' text-black text-sm flex'>Testimonies </Link>
<Link to="/careers" className=' text-black  text-sm flex '>Careers </Link>
<Link to="/podcast" className='text-black text-sm flex'>Podcasts</Link>
<Link to="/blog" className='text-black text-sm flex'>Blogs</Link> 
<Link to="/faq" className=' text-black text-sm flex'>FAQs</Link>      
</section>
<section className='footer_lower flex bg-stone-50 content-center justify-evenly'>
{/*<Link to="/logo" className="text-3xl font-bold"><h3>TRi<span>ANf</span></h3></Link>*/}
<Link to="/logo" className="text-3xl font-bold"><h3>TRi<span>ANf</span></h3></Link>
{/*<h2 className='font-semibold'>Learning & Assessment</h2> 
<p>© 2026 TRiANf Learning & Assessment. All rights reserved. Follow us</p>*/}

   
</section>
      
    </div>
  );
}

export default Footer;
